/* eslint-disable no-underscore-dangle */
import { Typography } from '@ag1/ui';
import { EduArticleTableOfContentsProps } from 'types/studio/eduHub';
import styles from './EduArticleTableOfContents.module.scss';
import { TableOfContentsItem } from './Item/TableOfContentsItem';

export const EduArticleTableOfContents = ({
  tableOfContentsHeadlines,
  headline
}: EduArticleTableOfContentsProps) => (
  <nav role="navigation" className={styles.root}>
    <Typography
      variant="portalText"
      size="1"
      weight="700"
      color="black-new"
      noPadding
      className={styles.headline}>
      {headline}
    </Typography>
    {tableOfContentsHeadlines && (
      <ul className={styles.list}>
        {tableOfContentsHeadlines.map((item, index) => (
          <TableOfContentsItem item={item} index={index} key={item._id} />
        ))}
      </ul>
    )}
  </nav>
);
